
import {defineComponent, PropType} from 'vue';
import {ModsType} from "@/types/IModsData";
import DataMixins from "@/mixins/DataMixins";
import {Tooltip} from "bootstrap";

export default defineComponent({
	name: 'MainCardComponent',
    props: {
        data: {
            type: Object as PropType<ModsType>,
            required: true
        },

    },
    computed: {
      getDesc() {
        return `<small class="me-2">Загружено&#32;&#8226;&#32; ${this.getStringTimestamp(this.data.timestamp)}</small>
        ${this.data.description}`
      }
    },
    methods: {
      initializeTooltips(): void {
        const tooltipElements : NodeList = document.querySelectorAll(
            `[data-bs-toggle="tooltip-${this.data.id}"]`
        )

        if (tooltipElements) {
          tooltipElements.forEach((el: any) => {
            const tooltipInstance = Tooltip.getInstance(el);

            if (tooltipInstance) {
              tooltipInstance.dispose();
            }
            new Tooltip(el);
          })
        }
      }
    },
    mounted() {
      this.initializeTooltips()
    },
    updated() {
      this.initializeTooltips()
    },
    mixins: [DataMixins]
})
